// extracted by mini-css-extract-plugin
module.exports = {"root":"segmented-control_root__1xuG7","block":"segmented-control_block__7NIqK"};